import { Box, Paper, Table, TableBody, TableContainer, TableHead } from "@mui/material";
import OrderSummaryTableRow from "./OrderSummaryTableRow";
import OrderSummaryTableHeaderRow from "./OrderSummaryTableHeaderRow";

function OrderSummaryTable ({orders}) {

  const orderSummaryTableRows= orders.map((order, orderIndex, ordersArray) => {

    const lastOrder = orderIndex > 0 ? ordersArray[orderIndex - 1] : null;

    return (
      <OrderSummaryTableRow
        order={formatOrder(order, lastOrder)}
      />
    )
  });
  
  return (
    <Box>
      <TableContainer component={Paper} sx={{maxWidth: "calc(100vw - 100px)", overflowX:"scroll"}}>
        <Table>
          <TableHead >
            <OrderSummaryTableHeaderRow />
          </TableHead>
          <TableBody>
            {orderSummaryTableRows}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export default OrderSummaryTable;

const formatOrder = (order, lastOrder) => {

  if (!lastOrder) {
    return order;
  }

  let formattedOrderProduct = {...order.product};

  for (const prop of ["productName", "originName"]) {
    if (order.product[prop] !== lastOrder.product[prop]) {
      return ({
        ...order, product: formattedOrderProduct
      });
    }

    formattedOrderProduct[prop] = "";

  }

  return ({
    ...order, product: formattedOrderProduct
  });

}



